<template>
  <div id="page-container">
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    mounted() {
      document.title = "CCT Portal"
    },
    component: {
        Header,
        Footer
    },
    components: { Header, Footer, Footer }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kanit&display=swap');
html {
  /* height: 100vh; */
}
body {
  margin: 0;
  height: 100%;
}
#page-container {
  min-height: 100%;
}
#app {
  font-family: 'Kanit';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
